import { ActionIcon, Loader, Modal, Table, Text, Tooltip } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import type { BillingReportSummary } from "../../services/api";

interface BillingHistoryModalProps {
	opened: boolean;
	accountName: string;
	reports: BillingReportSummary[];
	loading: boolean;
	onClose: () => void;
	onDownload: (report: BillingReportSummary) => void;
}

// "2026-10" -> "October 2026"
function toMonthLabel(period: string) {
	const [year, month] = period.split("-").map(Number);
	return new Date(year, month - 1).toLocaleString(undefined, {
		month: "long",
		year: "numeric",
	});
}

function BillingHistoryModal({
	opened,
	accountName,
	reports,
	loading,
	onClose,
	onDownload,
}: BillingHistoryModalProps) {
	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title={`Past Billing Reports - ${accountName}`}
			size="lg"
			centered>
			{loading ? (
				<Loader />
			) : reports.length === 0 ? (
				<Text size="sm">
					No reports archived yet. One is saved on the 1st of every month.
				</Text>
			) : (
				<Table.ScrollContainer minWidth={400}>
					<Table
						striped
						highlightOnHover>
						<Table.Thead>
							<Table.Tr>
								<Table.Th>Month</Table.Th>
								<Table.Th>Generated</Table.Th>
								<Table.Th>Active / Total</Table.Th>
								<Table.Th />
							</Table.Tr>
						</Table.Thead>
						<Table.Tbody>
							{reports.map((report) => (
								<Table.Tr key={report._id}>
									<Table.Td>{toMonthLabel(report.period)}</Table.Td>
									<Table.Td>
										{new Date(report.createdAt).toLocaleDateString()}
									</Table.Td>
									<Table.Td>
										{report.activeLicenses} / {report.totalLicenses}
									</Table.Td>
									<Table.Td>
										<Tooltip label="Download">
											<ActionIcon
												variant="light"
												color="violet"
												aria-label={`Download ${toMonthLabel(report.period)}`}
												onClick={() => onDownload(report)}>
												<IconDownload size={16} />
											</ActionIcon>
										</Tooltip>
									</Table.Td>
								</Table.Tr>
							))}
						</Table.Tbody>
					</Table>
				</Table.ScrollContainer>
			)}
		</Modal>
	);
}

export default BillingHistoryModal;
